jQuery(function ($) {
    const html = $('html');
    const header = $('header');
    const menu = $('.header-nav ul.menu');
    const body = $('body');
    const isMobile = body.hasClass('wp-is-mobile');
    const search = $('.header-search');
    const searchFormWrapper = $('.header-search-form-wrapper');

    const toggleMenu = function () {
        deactivateSearch();
        html.toggleClass('menu-open');
        header.find('.menu > .menu-item.is-open').removeClass('is-open');
    }

    const deactivateMenu = function () {
        menu.find('.menu-item.is-open').removeClass('is-open');
        html.removeClass('menu-open');
    }

    const deactivateSearch = function () {
       // console.log('deactivate Search')
        html.removeClass('search-open');
        searchFormWrapper.removeClass('is-open').find('input[type=search]').trigger('blur');
    }

    const activateSearch = function () {
        html.addClass('search-open');
        searchFormWrapper.addClass('is-open').find('input[type=search]').focus();
    }

    function toggleSearchOpen() {
        deactivateMenu();
        if (html.hasClass('search-open')) {
            deactivateSearch();
        } else {
            activateSearch();
        }
    }

    // Toggle main menu
    header.on('click', '.header-toggle', function () {
        toggleMenu();
    });

    // Close main menu if we are navigating on page
    $('.submenu').on('click', 'a[aria-current="page"]', function (e) {
        // If this is something with children, then do nothing
        if ($(this).parent().hasClass('menu-item-has-children')) {
            return;
        }
        e.preventDefault();
        $(this).parents('.menu-item').removeClass('is-open');
        html.removeClass('menu-open');
    });


    // Toggle main menu submenus
    menu.find('.menu-item-has-children > a').on('click', function (e) {

        e.preventDefault();
        const parent = $(this).parent('.menu-item');

        // if this is top level menu item
        if (parent.parent().hasClass('menu')) {
            deactivateSearch();
        }

        if (parent.hasClass('is-open')) {
            parent.removeClass('is-open');
        } else {
            html.addClass('menu-open');
            parent.addClass('is-open').siblings().removeClass('is-open');
        }

        if (!header.find('.menu > .menu-item').hasClass('is-open')) {
            html.removeClass('menu-open');
        }
    });

    // Close main menu submenu
    menu.find('.submenu-back').on('click', function () {
        $(this).closest('.menu-item.is-open').removeClass('is-open');
    });


    // Close menu off click
    $('.backdrop').on('click', function () {
        deactivateMenu();
        deactivateSearch();
    });

    // Show hide header menu on scroll
    const scrolling = 5;
    const offset = 50;
    var previousScroll = $(document).scrollTop();


    $(window).on('scroll', function () {
        var currentScroll = $(document).scrollTop();

        if (currentScroll > previousScroll && currentScroll > offset) {
            header.removeClass('slide-down').addClass('slide-up');
        }

        if (currentScroll < previousScroll) {
            header.removeClass('slide-up').addClass('slide-down');
        }

        previousScroll = currentScroll;

        if (currentScroll > scrolling) {
            header.addClass('scrolled-down');
            // showDarkLogo();
        } else {
            header.removeClass('scrolled-down');
            // showLightLogo();
        }
    });

    if (body.offset().top) {
        $(window).trigger('scroll');
    }

    /**
     * Search Toggle
     */

    search.on('click', '.header-search-toggle', toggleSearchOpen);

    $('.search-form-clear').on('click', function () {
        toggleSearchOpen()
    });

});


// Get the list items
const listItems = document.querySelectorAll('.wp-block-navigation__container li');
const buttons = document.querySelectorAll('header .wp-block-button');

// Function to add the show-menu-item class to list items
function showMenuItems() {
    // Calculate delay for each list item
    let delay = 1  // Adjust delay as needed
    let count = 0;
    listItems.forEach((item, index) => {
        delay = (index + 1) * 100;
        // Add class after delay
        if(index==0){
            //console.log('index '+index)
            item.classList.add('show-menu-item');
            delay=0;
        }else{
            setTimeout(() => {
                item.classList.add('show-menu-item');
            }, delay);
        }
       
        count++;
    });
    buttons.forEach((item, index) => {
        // Add class after delay
        delay = (index + 1 + count) * 100;
        setTimeout(() => {
            item.classList.add('show-menu-item');
        }, delay);
    });
}

// Call the function when the menu becomes visible
// For example, you can call this function when the menu is clicked to open
document.querySelector('.wp-block-navigation__responsive-container-open').addEventListener('click', () => {
    hideMenuItems();
    showMenuItems();
});

// Function to remove the show-menu-item class from list items
function hideMenuItems() {
    listItems.forEach(item => {
        item.classList.remove('show-menu-item');
    });
    buttons.forEach(item => {
        item.classList.remove('show-menu-item');
    });
}

// Call the function to hide menu items when the close button is clicked
document.querySelector('.wp-block-navigation__responsive-container-close').addEventListener('click', () => {
    hideMenuItems();
});

